import { PatchesGridWebComponent } from '../component/PatchesGridWebComponent';
import {
  BaseWebComponentController,
  IListenerConfig,
} from '../../../../../../../../framework/BaseWebComponentController';
import { PatchesGridView } from '../view/PatchesGridView';
import { templatePatchesGrid } from '../view/template';
import { GridEvents } from '../../../../../../../../grid/types/common';
import { PatchesGridEvents } from '../types';

export class PatchesGridController extends BaseWebComponentController {
  public component: PatchesGridWebComponent;
  public view: PatchesGridView;
  public viewConstructor: typeof PatchesGridView;

  constructor(component: PatchesGridWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: PatchesGridView,
      viewTemplate: templatePatchesGrid,
    });
  }

  injectDependencies(dependencies) {
    super.injectDependencies(dependencies);

    this.view.targets = this.component.targets;
  }

  computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$gridView,
        event: GridEvents.SELECT_ROWS,
        callback: this.handleSelectRowsEvent,
      },
      {
        element: this.view.dom.$gridView,
        event: GridEvents.ROW_CLICKED,
        callback: this.handleRowClickedEvent,
      },
    ];
  }

  private handleSelectRowsEvent(event: CustomEvent) {
    this.component.dispatchEvent(
      new CustomEvent(PatchesGridEvents.SELECT_ROWS, {
        detail: {
          selectedItemsNo: event.detail.selectedItemsData.length,
        },
        bubbles: true,
        composed: true,
      })
    );
  }

  private handleRowClickedEvent(event: CustomEvent) {
    if (!event.detail.rowDetails) {
      return;
    }

    this.component.dispatchEvent(
      new CustomEvent(PatchesGridEvents.ROW_CLICKED, {
        detail: event.detail,
        bubbles: true,
        composed: true,
      })
    );
  }
}
